import { InfoIcon, XIcon } from 'lucide-react';
import { useCart, useCartActions } from '../../contexts/StoreContext';
import { adjustmentText } from './cartRules';

/**
 * De melding als de mand bij het openen of verversen van de catalogus is aangepast.
 * Staat in de mand én bij afrekenen; wegklikken geldt voor beide.
 */
export function CartAdjustedNotice({
  className = ''
}: {
  className?: string;
}) {
  const {
    adjustments
  } = useCart();
  const {
    dismissAdjustments
  } = useCartActions();
  if (!adjustments.length) return null;
  return <div role="status" className={`flex items-start gap-3 bg-blush p-4 text-[14px] leading-relaxed text-ink ${className}`} data-id="element-6829" data-mp="2lnde4qy3yfut">
      <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-6830" data-mp="26z8rjbvxpk6r" />
      <p className="min-w-0 flex-1" data-id="element-6831" data-mp="2bwshva5wpnf2">{adjustmentText(adjustments)}</p>
      <button type="button" onClick={dismissAdjustments} aria-label="Melding sluiten" className="-m-2 inline-flex h-9 w-9 shrink-0 items-center justify-center text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-6832" data-mp="2zn4x763hemfo">
        <XIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6833" data-mp="x0aqcd3tx3i6" />
      </button>
    </div>;
}